import { CSSProperties } from 'react';
import { Style } from '@capacitor/status-bar';

import { TMoplaColors } from '@mopla/mui';

import type { TMplPageHeaderVariant } from './MplPageHeader';

export interface IVariantConfig {
	bgColor: TMoplaColors | CSSProperties['backgroundColor'];
	textColor: TMoplaColors | CSSProperties['color'];
	statusBarColor: Style | null;
}

export const variantConfigs: Record<TMplPageHeaderVariant, IVariantConfig> = {
	primary: {
		bgColor: 'primary.main',
		textColor: 'neutral.0',
		statusBarColor: Style.Dark,
	},
	primary_light: {
		bgColor: 'primary.light',
		textColor: 'primary.main',
		statusBarColor: Style.Dark,
	},
	primaryDark: {
		bgColor: 'primary.dark',
		textColor: 'neutral.0',
		statusBarColor: Style.Dark,
	},
	secondary: {
		bgColor: 'secondary.main',
		textColor: 'primary.main',
		statusBarColor: Style.Light,
	},
	'neutral.0': {
		bgColor: 'neutral.0',
		textColor: 'primary.main',
		statusBarColor: Style.Light,
	},
};
